import { useEffect } from 'react'

const ARIA_LABEL_COOKIE_CONSENT = 'cookieconsent'

export const useStyleRDCookiesBanner = () => {
  useEffect(() => {
    const elements = document.querySelectorAll('[role="dialog"]')

    elements.forEach((el) => {
      if (el.getAttribute('aria-label') === ARIA_LABEL_COOKIE_CONSENT) {
        const element = el as HTMLElement
        element.style.padding = '20px'

        const span = element.querySelector('span')
        const buttonContainer = element.querySelector('div')

        if (span) {
          span.style.fontSize = '14px'
        }

        if (buttonContainer) {
          buttonContainer.style.padding = '12px'
        }
      }
    })
  }, [])
}
